var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGithubSecret24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8378 3.62162H4.16216C3.86363 3.62162 3.62162 3.86363 3.62162 4.16216V19.8378C3.62162 20.1364 3.86363 20.3784 4.16216 20.3784H19.8378C20.1364 20.3784 20.3784 20.1364 20.3784 19.8378V4.16216C20.3784 3.86363 20.1364 3.62162 19.8378 3.62162ZM4.16216 2C2.96803 2 2 2.96803 2 4.16216V19.8378C2 21.032 2.96803 22 4.16216 22H19.8378C21.032 22 22 21.032 22 19.8378V4.16216C22 2.96803 21.032 2 19.8378 2H4.16216Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7C12.3997 7 12.7237 7.32399 12.7237 7.72365V10.6818L15.2299 9.08684C15.5672 8.87227 16.0145 8.97166 16.229 9.30885C16.4436 9.64602 16.3442 10.0933 16.007 10.3079L13.3479 12L16.007 13.6921C16.3442 13.9067 16.4436 14.354 16.229 14.6912C16.0145 15.0283 15.5672 15.1278 15.2299 14.9131L12.7237 13.3182V16.2763C12.7237 16.676 12.3997 17 12 17C11.6003 17 11.2764 16.676 11.2764 16.2763V13.3183L8.77009 14.9131C8.43291 15.1278 7.98563 15.0283 7.77106 14.6912C7.55649 14.354 7.65589 13.9067 7.99307 13.6921L10.6521 12L7.99307 10.3079C7.65589 10.0933 7.55649 9.64602 7.77106 9.30885C7.98563 8.97166 8.43291 8.87227 8.77009 9.08684L11.2764 10.6817V7.72365C11.2764 7.32399 11.6003 7 12 7Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGithubSecret24);
export default __webpack_public_path__ + "static/media/icon_github_secret_24.77e83302da0d982fd31dcbf1824e378b.svg";
export { ForwardRef as ReactComponent };